import { cva } from 'class-variance-authority';

export const TOAST_TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  NEUTRAL: 'neutral'
} as const;

export const TOAST_DISPLAY = {
  INLINE: 'inline',
  STACKED: 'stacked'
} as const;

export const toastVariants = cva(
  'relative flex items-start w-full rounded-sm transition-colors py-m pr-9xl pl-l gap-2xs shadow-lg bg-primary text-primary',
  {
    variants: {
      type: {
        info: '',
        success: '',
        warning: '',
        error: '',
        neutral: ''
      }
    },
    defaultVariants: {
      type: 'info'
    }
  }
);

export const toastContentVariants = cva('flex-1 min-w-0 flex', {
  variants: {
    display: {
      inline: 'flex-row items-center gap-4xs',
      stacked: 'flex-col gap-4xs'
    }
  },
  defaultVariants: {
    display: 'stacked'
  }
});

export const toastTextContentVariants = cva('flex flex-col gap-4xs', {
  variants: {
    display: {
      inline: '',
      stacked: ''
    }
  },
  defaultVariants: {
    display: 'stacked'
  }
});

export const toastActionsVariants = cva('flex gap-2xs', {
  variants: {
    display: {
      inline: '',
      stacked: ''
    }
  },
  defaultVariants: {
    display: 'stacked'
  }
});


export const toastIconVariants = cva('flex items-center justify-center w-l h-l', {
  variants: {
    type: {
      info: 'text-cic-blue-600',
      success: 'text-success-600',
      warning: 'text-warning-600',
      error: 'text-error-600',
      neutral: 'text-gray-600'
    }
  }
});

export const toastIconWrapperVariants = cva(
  'flex-shrink-0 rounded-full flex items-center justify-center w-5xl h-5xl border-[4px]',
  {
    variants: {
      type: {
        info: 'bg-cic-blue-100 border-cic-blue-50',
        success: 'bg-success-100 border-success-50',
        warning: 'bg-warning-100 border-warning-50',
        error: 'bg-error-100 border-error-50',
        neutral: 'bg-gray-100 border-gray-50'
      }
    }
  }
);

export const toastCloseButtonVariants = cva(
  'absolute top-2xs right-s flex items-center justify-center p-xs rounded-sm cursor-pointer border-none bg-transparent text-secondary'
);
